// material-ui
import { CircularProgress, Typography } from '@mui/material';

// project imports
import NavGroup from '../../shared/Sidebar/MenuList/NavGroup';
import menuItem from 'menu-items';
import { useAdminRole } from 'hooks/master/roles.hooks';
import { Box } from '@mui/system';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
	const { data, isLoading } = useAdminRole();
	let updatedMenuItems;
	if (data && data.isAdmin === false) {
		updatedMenuItems = menuItem.items.filter(item => item.id !== 'masters');
	} else {
		updatedMenuItems = menuItem.items;
	}

	console.log(updatedMenuItems.items);
	const navItems = updatedMenuItems.map(item => {
		switch (item.type) {
			case 'group':
				return <NavGroup key={item.id} item={item} />;
			default:
				return (
					<Typography key={item.id} variant="h6" color="error" align="center">
						Menu Items Error
					</Typography>
				);
		}
	});

	return (
		<>
			{isLoading ? (
				<Box display="flex" justifyContent="center" alignItems="center">
					<CircularProgress />
				</Box>
			) : (
				navItems
			)}
		</>
	);
};

export default MenuList;
